import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ReferralTerms = () => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-background-dark font-display">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Header />

        <main className="py-12" data-testid="referral-terms-main">
          <div className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-black text-gray-900 dark:text-white mb-2">
              Condiciones del Programa de Referidos
            </h1>
            <p className="text-sm text-gray-500 dark:text-gray-400">
              Última actualización: mayo 2026 · Titular: Nexus Nova Systems SpA
            </p>
          </div>

          <div className="bg-white dark:bg-[#1a2530] rounded-2xl p-8 space-y-6 border border-gray-100 dark:border-[#283039]">
            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">1. Naturaleza del beneficio</h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Las recompensas del programa consisten en <strong>créditos internos de uso</strong> dentro de la plataforma GPT-JDP.
                Estos créditos <strong>no constituyen dinero</strong>, no son convertibles a moneda de curso legal,
                no son transferibles entre cuentas y no generan intereses.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">2. Requisitos para participar</h2>
              <ul className="text-gray-700 dark:text-gray-300 space-y-2 list-disc pl-6">
                <li>Tener una cuenta activa en GPT-JDP.</li>
                <li>Compartir tu código o link personal con nuevas personas.</li>
                <li>Los referidos deben ser cuentas nuevas, únicas y verificables (email confirmado).</li>
                <li>No se aceptan cuentas duplicadas, ficticias o creadas artificialmente.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">3. Niveles y recompensas referenciales</h2>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-gray-200 dark:border-gray-700">
                      <th className="text-left py-2">Nivel</th>
                      <th className="text-left py-2">Créditos por referido</th>
                      <th className="text-left py-2">Bono adicional</th>
                    </tr>
                  </thead>
                  <tbody className="text-gray-700 dark:text-gray-300">
                    <tr className="border-b border-gray-100 dark:border-gray-800"><td className="py-2">Bronce</td><td>+500</td><td>+500 (primer referido)</td></tr>
                    <tr className="border-b border-gray-100 dark:border-gray-800"><td className="py-2">Plata</td><td>+750</td><td>+2.000</td></tr>
                    <tr className="border-b border-gray-100 dark:border-gray-800"><td className="py-2">Oro</td><td>+1.000</td><td>+5.000</td></tr>
                    <tr><td className="py-2">Platino</td><td>+1.500</td><td>+15.000</td></tr>
                  </tbody>
                </table>
              </div>
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-3">
                Los montos son referenciales y pueden actualizarse según condiciones comerciales vigentes.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">4. Duración del beneficio</h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                La cantidad de créditos entregada no equivale a una duración fija en meses. La <strong>duración real</strong>
                depende del consumo del usuario y del módulo utilizado (chat, generación de texto, imágenes, etc.).
                Cualquier estimación de "días de uso" tiene carácter meramente ilustrativo.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">5. Vigencia y anti-fraude</h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Nexus Nova Systems SpA se reserva el derecho de suspender, revocar o ajustar las recompensas del programa
                ante detección de abuso, fraude, uso indebido, creación de cuentas ficticias, uso de bots o cualquier
                actividad contraria a los Términos de Servicio.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">6. Modificaciones</h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Las condiciones de este programa pueden ser actualizadas por Nexus Nova Systems SpA. Cualquier cambio
                sustancial será notificado con anticipación razonable a través del sitio o del correo institucional
                asociado a la cuenta.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-2">7. Contacto</h2>
              <p className="text-gray-700 dark:text-gray-300 leading-relaxed">
                Dudas o reclamos del programa: <a href="mailto:contact@gpt-jdp.com" className="text-primary hover:underline">contact@gpt-jdp.com</a>
              </p>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default ReferralTerms;
